module.exports = __webpack_public_path__ + "img/verify-img.afc598b1.png";